"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.publishEvents = exports.post = exports.getConfigJson = exports.get = exports.baseRequestHeaders = exports.EVENTS_PATH = exports.CONFIG_PATH = exports.EVENT_URL = exports.BASE_URL = exports.HOST = void 0;
var utils_1 = require("./utils");
var axios_1 = __importDefault(require("axios"));
var axios_retry_1 = __importDefault(require("axios-retry"));
var axiosClient = axios_1.default.create({
    validateStatus: function (status) { return status < 400 && status >= 200; },
});
(0, axios_retry_1.default)(axiosClient, {
    retries: 5,
    retryDelay: function (retryCount) {
        return Math.pow(2, retryCount) * 1000;
    },
    retryCondition: function (error) {
        return error.response.status >= 500;
    }
});
exports.HOST = '.devcycle.com';
exports.BASE_URL = 'https://sdk-api';
exports.EVENT_URL = 'https://events';
exports.CONFIG_PATH = '/v1/sdkConfig';
exports.EVENTS_PATH = '/v1/events';
var baseRequestHeaders = function (environmentKey) {
    return __assign({ 'Content-Type': 'application/json' }, (environmentKey ? { 'Authorization': environmentKey } : {}));
};
exports.baseRequestHeaders = baseRequestHeaders;
var get = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axiosClient.request({
                    method: 'GET',
                    url: "".concat(url),
                    headers: (0, exports.baseRequestHeaders)()
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.get = get;
var getConfigJson = function (environmentKey, user) { return __awaiter(void 0, void 0, void 0, function () {
    var queryParams, url, res, ex_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                queryParams = "".concat((0, utils_1.serializeUser)(user));
                url = "".concat(exports.BASE_URL).concat(exports.HOST).concat(exports.CONFIG_PATH, "?envKey=").concat(environmentKey).concat(queryParams && '&' + queryParams);
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, (0, exports.get)(url)];
            case 2:
                res = _b.sent();
                return [2 /*return*/, res.data];
            case 3:
                ex_1 = _b.sent();
                console.error("Request to get config failed for url: ".concat(url, ", ") +
                    "response message: ".concat(ex_1.message, ", response data: ").concat((_a = ex_1 === null || ex_1 === void 0 ? void 0 : ex_1.response) === null || _a === void 0 ? void 0 : _a.data));
                throw new Error('Failed to download DevCycle config.');
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.getConfigJson = getConfigJson;
var post = function (url, environmentKey, body) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axiosClient.request({
                    method: 'POST',
                    url: url,
                    data: body,
                    headers: (0, exports.baseRequestHeaders)(environmentKey)
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.post = post;
var publishEvents = function (envKey, config, user, events) { return __awaiter(void 0, void 0, void 0, function () {
    var payload, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!envKey) {
                    throw new Error('Missing envKey to publish events to Events API');
                }
                payload = (0, utils_1.generateEventPayload)(config, user, events);
                console.log("Submit Events Payload: ".concat(JSON.stringify(payload)));
                return [4 /*yield*/, (0, exports.post)("".concat(exports.EVENT_URL).concat(exports.HOST).concat(exports.EVENTS_PATH), envKey, payload)];
            case 1:
                res = _a.sent();
                if (res.status !== 201) {
                    console.error("Error posting events, status: ".concat(res.status, ", body: ").concat(res.data));
                }
                else {
                    console.log("Posted Events, status: ".concat(res.status, ", body: ").concat(res.data));
                }
                return [2 /*return*/, res];
        }
    });
}); };
exports.publishEvents = publishEvents;
exports.default = {
    get: exports.get,
    post: exports.post,
    getConfigJson: exports.getConfigJson,
    publishEvents: exports.publishEvents
};
//# sourceMappingURL=Request.js.map